function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.slice.js";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Component } from 'react';
import { translate, clearLocalStorage } from '../../utils/helpers';
import PropTypes from 'prop-types';
import SubmittedItem from '../SubmittedItem';
import Form from '../../utils/Form';
import FormErrors from '../FormErrors';
import _isEmpty from 'lodash/isEmpty';
import { API_URL, LANG, MAIN_COLOR, SITE_NAME, DEFAULT_LANG } from '../../utils/constant';

var SubmitPage = /*#__PURE__*/function (_Component) {
  _inherits(SubmitPage, _Component);

  var _super = _createSuper(SubmitPage);

  function SubmitPage(props, context) {
    var _this;

    _classCallCheck(this, SubmitPage);

    _this = _super.call(this, props, context);

    _defineProperty(_assertThisInitialized(_this), "setFields", function (fields, fieldName) {
      var shouldValidateForm = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      _this.setState(_defineProperty({}, fieldName, fields), function () {
        if (shouldValidateForm) {
          _this.validateForm();
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "validateForm", function () {
      var fields = _this.state.isSameAddress ? _this.state.billingFields : [].concat(_toConsumableArray(_this.state.billingFields), _toConsumableArray(_this.state.shippingFields));

      _this.setState({
        formValid: fields.filter(function (field) {
          return field.valid === false;
        }).length === 0
      });
    });

    _defineProperty(_assertThisInitialized(_this), "deliveryIdenticalToBilling", function () {
      var isSameAddress = _this.sameAddressRef.current.checked;

      _this.setState({
        isSameAddress: isSameAddress
      }, _this.validateForm);
    });

    _defineProperty(_assertThisInitialized(_this), "submit", function () {
      if (_this.billingFormRef.current.isFormValid()) {
        _this.createPost();

        clearLocalStorage();

        _this.context.router.history.push('/submission');
      }
    });

    _defineProperty(_assertThisInitialized(_this), "boolToString", function (val) {
      if (val) return '1';else return '0';
    });

    _defineProperty(_assertThisInitialized(_this), "createPost", function () {
      var fields = {
        billing: {},
        shipping: {},
        comments: _this.props.comments,
        otherProducts: _this.state.cart.otherProducts,
        products: _this.state.cart.cart,
        same_address: _this.boolToString(document.getElementById('same-address').checked),
        alreadyClient: _this.state.alreadyClient,
        sendTo: _this.getSubmissionEmail(),
        siteName: SITE_NAME,
        mainColor: MAIN_COLOR,
        lang: LANG,
        defaultLang: DEFAULT_LANG,
        websiteEmail: _this.getWebsiteEmail()
      };
      var url = API_URL + '/soumission';

      _this.state.billingFields.map(function (field) {
        fields.billing[field.name] = field.value;
      });

      _this.state.shippingFields.map(function (field) {
        fields.shipping[field.name] = field.value;
      });

      fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(fields)
      }).then(function (res) {
        if (res.status === 204) return '';
        return res.json();
      });
    });

    _defineProperty(_assertThisInitialized(_this), "getCartRules", function () {
      return document.querySelector('#shop-page').getAttribute('cart-rules');
    });

    _defineProperty(_assertThisInitialized(_this), "getEmailBranch", function () {
      return document.querySelector('#shop-page').getAttribute('email-branch');
    });

    _defineProperty(_assertThisInitialized(_this), "getSubmissionEmail", function () {
      return document.querySelector('#shop-page').getAttribute('cart-submission');
    });

    _defineProperty(_assertThisInitialized(_this), "getPhoneBranch", function () {
      return document.querySelector('#shop-page').getAttribute('phone-branch');
    });

    _defineProperty(_assertThisInitialized(_this), "getWebsiteEmail", function () {
      var websiteEmail = document.querySelector('#shop-page').getAttribute('cart-submission');
      return websiteEmail !== '' ? 'website@' + websiteEmail.split('@')[1] : 'siteweb@sani-depot.ca';
    });

    _this.newsletterRef = /*#__PURE__*/React.createRef();
    _this.sameAddressRef = /*#__PURE__*/React.createRef();
    _this.billingFormRef = /*#__PURE__*/React.createRef();
    _this.shippingFormRef = /*#__PURE__*/React.createRef();
    _this.state = {
      isSameAddress: true,
      cart: _this.props,
      otherProducts: _this.props,
      billingFields: [{
        name: 'bonLivraison',
        error: '',
        needValidation: false,
        valid: true,
        placeholder: translate('Purchase order', 'Bon de livraison'),
        type: 'text',
        value: ''
      }, {
        name: 'firstName',
        error: '',
        needValidation: true,
        valid: false,
        placeholder: translate('First name', 'Prénom'),
        type: 'text',
        value: ''
      }, {
        name: 'lastName',
        error: '',
        needValidation: true,
        valid: false,
        placeholder: translate('Last name', 'Nom'),
        type: 'text',
        value: ''
      }, {
        name: 'email',
        error: '',
        needValidation: true,
        valid: false,
        placeholder: translate('Email', 'Courriel'),
        type: 'email',
        value: ''
      }, {
        name: 'company',
        error: '',
        needValidation: true,
        valid: false,
        placeholder: translate('Company', 'Société'),
        type: 'text',
        value: ''
      }, {
        name: 'address',
        error: '',
        needValidation: true,
        valid: false,
        placeholder: translate('Address', 'Adresse'),
        type: 'text',
        value: ''
      }, {
        name: 'address2',
        error: '',
        needValidation: false,
        valid: true,
        placeholder: translate('Suite, Building', 'Suite, Batiment'),
        type: 'text',
        value: ''
      }, {
        name: 'postalCode',
        error: '',
        needValidation: true,
        valid: false,
        placeholder: translate('Postal Code', 'Code postal'),
        type: 'text',
        value: ''
      }, {
        name: 'city',
        error: '',
        needValidation: true,
        valid: false,
        placeholder: translate('City', 'Ville'),
        type: 'text',
        value: ''
      }, {
        name: 'province',
        error: '',
        needValidation: false,
        valid: true,
        placeholder: translate('Province', 'Province'),
        type: 'select',
        value: ''
      }, {
        name: 'phone',
        error: '',
        needValidation: true,
        valid: false,
        placeholder: translate('Phone', 'Téléphone'),
        type: 'text',
        value: ''
      }],
      shippingFields: [{
        name: 'firstName',
        error: '',
        needValidation: true,
        valid: false,
        placeholder: translate('First name', 'Prénom'),
        type: 'text',
        value: ''
      }, {
        name: 'lastName',
        error: '',
        needValidation: true,
        valid: false,
        placeholder: translate('Last name', 'Nom'),
        type: 'text',
        value: ''
      }, {
        name: 'email',
        error: '',
        needValidation: true,
        valid: false,
        placeholder: translate('Email', 'Courriel'),
        type: 'email',
        value: ''
      }, {
        name: 'company',
        error: '',
        needValidation: true,
        valid: false,
        placeholder: translate('Company', 'Société'),
        type: 'text',
        value: ''
      }, {
        name: 'address',
        error: '',
        needValidation: true,
        valid: false,
        placeholder: translate('Address', 'Adresse'),
        type: 'text',
        value: ''
      }, {
        name: 'address2',
        error: '',
        needValidation: false,
        valid: true,
        placeholder: translate('Suite, Building', 'Suite, Batiment'),
        type: 'text',
        value: ''
      }, {
        name: 'postalCode',
        error: '',
        needValidation: true,
        valid: false,
        placeholder: translate('Postal Code', 'Code postal'),
        type: 'text',
        value: ''
      }, {
        name: 'city',
        error: '',
        needValidation: true,
        valid: false,
        placeholder: translate('City', 'Ville'),
        type: 'text',
        value: ''
      }, {
        name: 'province',
        error: '',
        needValidation: true,
        valid: true,
        placeholder: translate('Province', 'Province'),
        type: 'select',
        value: translate('Alberta', 'Alberta')
      }, {
        name: 'phone',
        error: '',
        needValidation: true,
        valid: false,
        placeholder: translate('Phone', 'Téléphone'),
        type: 'text',
        value: ''
      }],
      provinces: [translate('Alberta', 'Alberta'), translate('British-Columbia', 'Colombie-Britannique'), translate('Prince Edward Island', 'Ile du Prince Édouard'), translate('Manitoba', 'Manitoba'), translate('New Brunswick', 'Nouveau Brunswick'), translate('Nova Scotia', 'Nouvelle Écosse'), translate('Ontario', 'Ontario'), translate('Quebec', 'Québec'), translate('Saskatchewan', 'Saskatchewan'), translate('Newfoundland and Labrador', 'Terre Neuve et Labrador'), translate('Northwest Territories', 'Territoires du Nord-Ouest'), translate('Nunavut', 'Nunavut'), translate('Yukon', 'Yukon')],
      alreadyClient: '0',
      formValid: false
    };
    return _this;
  }

  _createClass(SubmitPage, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          cart = _this$props.cart,
          otherProducts = _this$props.otherProducts,
          comments = _this$props.comments;
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        className: "container"
      }, /*#__PURE__*/React.createElement("h1", {
        className: "your-cart main-bg-after"
      }, translate('Your cart ', 'Votre panier'))), /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-12 submission-page"
      }, /*#__PURE__*/React.createElement("div", {
        className: "left col-lg-7 form-group"
      }, /*#__PURE__*/React.createElement("span", {
        className: "title"
      }, translate('BILLING ADDRESS ', 'ADRESSE DE FACTURATION')), /*#__PURE__*/React.createElement("div", {
        className: "billing"
      }, /*#__PURE__*/React.createElement(Form, {
        fields: this.state.billingFields,
        provinces: this.state.provinces,
        ref: this.billingFormRef,
        setParentState: function setParentState(billingFields, shouldValidateForm) {
          return _this2.setFields(billingFields, 'billingFields', shouldValidateForm);
        }
      }), /*#__PURE__*/React.createElement(FormErrors, {
        fields: this.state.billingFields.filter(function (field) {
          return field.error !== '';
        })
      })), /*#__PURE__*/React.createElement("span", {
        className: "title"
      }, translate('SHIPPING ADDRESS ', 'ADRESSE DE LIVRAISON')), /*#__PURE__*/React.createElement("div", {
        className: "shipping"
      }, /*#__PURE__*/React.createElement("div", {
        className: "custom-control solid-checkbox mb-3"
      }, /*#__PURE__*/React.createElement("input", {
        type: "checkbox",
        className: "custom-control-input main-bg-before",
        onChange: function onChange() {
          return _this2.deliveryIdenticalToBilling();
        },
        ref: this.sameAddressRef,
        id: "same-address",
        checked: this.state.isSameAddress
      }), /*#__PURE__*/React.createElement("label", {
        htmlFor: "same-address",
        className: "custom-control-label first-uppercase main-bg-before"
      }, translate('SAME AS BILLING ', 'IDENTIQUE À CELLE DE LA FACTURE'))), !this.state.isSameAddress ? /*#__PURE__*/React.createElement("div", {
        className: "billing"
      }, /*#__PURE__*/React.createElement(Form, {
        fields: this.state.shippingFields,
        provinces: this.state.provinces,
        ref: this.shippingFormRef,
        setParentState: function setParentState(shippingFields, shouldValidateForm) {
          return _this2.setFields(shippingFields, 'shippingFields', shouldValidateForm);
        }
      }), /*#__PURE__*/React.createElement(FormErrors, {
        fields: this.state.shippingFields.filter(function (field) {
          return field.error !== '';
        })
      })) : null)), /*#__PURE__*/React.createElement("div", {
        className: "right col-lg-5 "
      }, /*#__PURE__*/React.createElement("div", {
        className: "items-section"
      }, /*#__PURE__*/React.createElement("span", {
        className: "title"
      }, translate('YOUR ITEMS', 'VOS ITEMS')), /*#__PURE__*/React.createElement("div", {
        className: "items"
      }, cart.map(function (item) {
        return /*#__PURE__*/React.createElement(SubmittedItem, {
          key: item.uniqId,
          item: item
        });
      })), _isEmpty(otherProducts) !== true ? /*#__PURE__*/React.createElement("span", {
        className: "title"
      }, translate('OTHER ITEMS', 'AUTRES ITEMS')) : null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        className: "items "
      }, otherProducts.map(function (otherProduct) {
        return /*#__PURE__*/React.createElement(SubmittedItem, {
          key: otherProduct.id,
          otherProduct: otherProduct
        });
      }))), /*#__PURE__*/React.createElement("div", {
        className: "grand-total"
      }), /*#__PURE__*/React.createElement("div", {
        className: "custom-control  solid-checkbox radio"
      }, /*#__PURE__*/React.createElement("div", {
        className: "radio-section"
      }, /*#__PURE__*/React.createElement("div", {
        className: "option"
      }, /*#__PURE__*/React.createElement("input", {
        className: "custom-control-input main-bg-before",
        type: "radio",
        name: "price",
        id: "forPrice",
        checked: this.state.alreadyClient === '0',
        onChange: function onChange() {
          return _this2.setState({
            alreadyClient: '0'
          });
        }
      }), /*#__PURE__*/React.createElement("label", {
        className: "custom-control-label",
        htmlFor: "forPrice"
      }, translate('I would like prices for these listed products', 'J’aimerais obtenir des prix concernant ces produits listés'))), /*#__PURE__*/React.createElement("div", {
        className: "option"
      }, /*#__PURE__*/React.createElement("input", {
        className: "custom-control-input main-bg-before",
        type: "radio",
        name: "price",
        id: "forOrder",
        checked: this.state.alreadyClient === '1',
        onChange: function onChange() {
          return _this2.setState({
            alreadyClient: '1'
          });
        }
      }), /*#__PURE__*/React.createElement("label", {
        className: "custom-control-label",
        htmlFor: "forOrder"
      }, /*#__PURE__*/React.createElement("span", null, translate('I am already a customer at ', 'Je suis déjà client chez ')), /*#__PURE__*/React.createElement("span", null, SITE_NAME), /*#__PURE__*/React.createElement("span", null, translate(', please order directly these products', ', veuillez passer ces produits directement en commande')))))), /*#__PURE__*/React.createElement("div", {
        className: "custom-control solid-checkbox"
      }, /*#__PURE__*/React.createElement("input", {
        type: "checkbox",
        className: "custom-control-input main-bg-before",
        ref: this.newsletterRef,
        id: "newsletter"
      }), /*#__PURE__*/React.createElement("label", {
        htmlFor: "newsletter",
        className: "custom-control-label first-uppercase"
      }, translate('Yes, I would like to receive informations regarding ', 'Oui, je désire recevoir des informations et nouveautés relatives à '), /*#__PURE__*/React.createElement("span", null, SITE_NAME))), comments ? /*#__PURE__*/React.createElement("div", {
        className: "comments"
      }, /*#__PURE__*/React.createElement("span", null, " ", translate('Comments', 'Commentaires')), /*#__PURE__*/React.createElement("textarea", {
        disabled: true,
        name: "",
        id: "",
        cols: "100",
        rows: "5",
        value: comments
      })) : null, /*#__PURE__*/React.createElement("button", {
        className: "btn btn-dark btn-cart-step-2 submit" // disabled={!this.state.formValid}
        ,
        onClick: this.submit
      }, translate('SUBMIT', 'ENVOYER')))))), /*#__PURE__*/React.createElement("div", {
        className: "row bottom-container"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-12"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-lg-7 rules-container"
      }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", {
        dangerouslySetInnerHTML: {
          __html: this.getCartRules()
        }
      }), /*#__PURE__*/React.createElement("i", {
        className: "fa fa-envelope fa-fw"
      }), /*#__PURE__*/React.createElement("span", null, this.getEmailBranch()), this.getPhoneBranch() !== '' ? /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("i", {
        className: "fa fa-phone fa-fw ml-4"
      }), this.getPhoneBranch()) : null)))));
    }
  }]);

  return SubmitPage;
}(Component);

_defineProperty(SubmitPage, "contextTypes", {
  router: PropTypes.object
});

SubmitPage.propTypes = {
  cart: PropTypes.array,
  disabled: PropTypes.bool,
  history: PropTypes.object,
  otherProducts: PropTypes.array,
  comments: PropTypes.string
};
export default SubmitPage;